import { Link } from "react-router-dom";
import { AlertTriangle, ArrowUpRight } from "lucide-react";
import { useAuth } from "@/lib/auth";

export const SubscriptionDisabledBanner = () => {
  const { subscriptionDisabled, user } = useAuth();
  if (!subscriptionDisabled || user?.impersonation) return null;

  return (
    <div role="alert" className="shrink-0 bg-[#F8ECE7] border-b border-[#D9B7AC] text-[#672F27] px-5 sm:px-8 pb-3.5 pt-16 md:py-3.5"
         data-testid="subscription-disabled-banner">
      <div className="flex flex-wrap sm:flex-nowrap items-start gap-x-3 gap-y-2 max-w-6xl mx-auto">
        <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" strokeWidth={1.8} />
        <div className="min-w-0 flex-1 text-sm leading-relaxed">
          <strong className="block" data-testid="subscription-disabled-reason">
            Account disabilitato {user?.access_state === "expired" ? "— abbonamento scaduto" : "— sospeso"}
          </strong>
          <span>Puoi consultare i dati ed esportare soltanto l’Excel dei prodotti. QR e cataloghi pubblici sono temporaneamente disattivati. Per riattivare l’account contatta Cosmely nell’area Assistenza creando un nuovo ticket.</span>
        </div>
        <Link to="/assistenza/nuovo" className="text-sm font-semibold underline underline-offset-4 whitespace-nowrap flex items-center gap-1 ml-8 sm:ml-0 self-center hover:text-[#1A1A1A] transition-colors"
              data-testid="subscription-disabled-support-link">
          Nuovo ticket <ArrowUpRight className="w-4 h-4" aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
};